import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { ExclamationFadedCircle } from "components/icons/ExclamationFadedCircle";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { useToast } from "hooks/useToast";
import { useUpdateTaskArchivalMutation } from "store/apis/taskList";
import { TaskDeadlineOverviewItem } from "types/Models/task";
import { BackendError } from "types/utils/error";

export const ArchiveFiling = ({
  isOpen,
  close,
  taskDeadline,
}: {
  isOpen: boolean;
  close: () => void;
  taskDeadline: TaskDeadlineOverviewItem;
}) => {
  const { alertToast, successToast } = useToast();
  const [updateTaskArchival, { isLoading: isArchiving }] =
    useUpdateTaskArchivalMutation();
  const isArchived = taskDeadline.is_archived;

  const handleArchive = async () => {
    try {
      await updateTaskArchival({
        taskId: taskDeadline.task_uuid!,
      }).unwrap();
      successToast({
        title: "Successful",
        message: `Filing ${
          isArchived ? "unarchived" : "archived"
        } successfully`,
      });
      close();
    } catch (error) {
      alertToast(
        { message: (error as BackendError)?.data?.error?.message },
        error as {}
      );
    }
  };

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <Modal.Body>
          <div>
            <span className="t-text-red t-flex t-items-center t-justify-center t-w-10 t-h-10 t-rounded-full t-shadow-[0px_0px_0px_4px_rgba(255, 78, 78, 0.05)] t-border t-border-red-0 t-border-solid t-bg-red-0">
              <ExclamationFadedCircle />
            </span>
            <p className="t-mb-2 t-text-subtext t-text-text-100 t-mt-5">
              {isArchived ? "Unarchive" : "Archive"} this filing?
            </p>
            <div className="t-text-body-sm t-text-text-30">
              Are you sure you want to {isArchived ? "unarchive" : "archive"}{" "}
              this filing?
            </div>
          </div>
        </Modal.Body>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Cancel</Button>
          </Modal.RawClose>
          <Button
            isLoading={isArchiving}
            disabled={isArchiving}
            customType={isArchived ? "primary" : "danger"}
            onClick={handleArchive}
          >
            Yes, {isArchived ? "unarchive" : "archive"}
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
